import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import * as validations from 'stash/utils/formValidations';
import { useBanjo } from '@stashinvest/react-banjo';

const LinkBankMicrosFormik = (props) => {
	const { getString } = useBanjo();
	const validationSchema = Yup.object().shape({
		accountType: Yup.string()
			.label(getString('management/property/accountType'))
			.required(getString('information/error/SelectAccountType'))
			.typeError(getString('information/error/SelectAccountType')),
		routingNumber: Yup.string()
			.label(getString('management/input/routingNumber'))
			.required(getString('information/error/EnterRoutingNumber9Digits'))
			.typeError(getString('information/error/EnterRoutingNumber9Digits'))
			.test({
				message: getString('information/error/NumbersOnly'),
				test: (val) => validations.yupMustContainNumbersOnly(val),
			})
			.test({
				message: getString('information/error/EnterRoutingNumber'),
				test: (val) => validations.yupExactLength(val, 9),
			}),
		accountNumber: Yup.string()
			.label(getString('management/input/externalBankAccountNumber'))
			.required(getString('information/error/EnterAccountNumber'))
			.typeError(getString('information/error/EnterAccountNumber'))
			.test({
				message: getString('information/error/NumbersOnly'),
				test: (val) => validations.yupMustContainNumbersOnly(val),
			})
			.test({
				message: getString('information/error/Min5Characters'),
				test: (val) => validations.yupMinLength(val, 5),
			}),
		confirmAccountNumber: Yup.string()
			.label(getString('management/input/confirmExternalBankAccount'))
			.required(getString('information/error/ConfirmAccountNumber'))
			.typeError(getString('information/error/ConfirmAccountNumber'))
			.oneOf(
				[Yup.ref('accountNumber'), null],
				getString('information/error/MustMatchAccountNumber')
			),
	});
	return (
		<Formik
			onSubmit={props.onSubmit}
			initialValues={props.initialValues}
			validationSchema={validationSchema}
		>
			{props.component}
		</Formik>
	);
};

LinkBankMicrosFormik.propTypes = {
	onSubmit: PropTypes.func,
	initialValues: PropTypes.object,
	component: PropTypes.node,
};

export default LinkBankMicrosFormik;
